var exports = {
  "U": "avatarRow__4M_ML7",
  "H": "moreCount__fwrix0",
};

module.exports = exports;
